import { render, staticRenderFns } from "./ServiceCommissionsSettings.vue?vue&type=template&id=0f722a46&scoped=true"
import script from "./ServiceCommissionsSettings.vue?vue&type=script&lang=js"
export * from "./ServiceCommissionsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f722a46",
  null
  
)

export default component.exports